import React from 'react'
import Settings from '../features/settings/index'

export default function SettingsPage() {
  return (
    
    <Settings />
  )

}